import * as R from 'ramda';

import { TextField } from '@atom/mui';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

const styles = {
  icon: {
    marginRight: '3px',
    marginTop: '-2px',
  },
};

interface Props {
  id: string;
  value: any;
  onChange: (value: any) => void;
  disabled: boolean;
  error: boolean;
  dataCyPrefix: string;
}

const CurrencyInput = ({
  id,
  value,
  onChange,
  disabled,
  error,
  dataCyPrefix,
}: Props) => {
  const handleChange = (number: string) => {
    onChange(!isNilOrEmpty(number) ? parseFloat(number) : '');
  };

  const data = !R.isNil(value) ? value : '';

  return (
    <TextField
      key={id}
      type="number"
      value={data}
      onChange={event => handleChange(event.target.value)}
      disabled={disabled}
      error={error}
      data-cy={`${dataCyPrefix}CurrencyInput`}
      slotProps={{
        input: { startAdornment: <span style={styles.icon}>$</span> },
      }}
    />
  );
};

export default CurrencyInput;
